"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactComponents = require("@ui-propulsion/react-components");
var _util = require("../util");
var Form = function Form(_ref) {
  var children = _ref.children,
    formState = _ref.formState,
    handleSubmit = _ref.handleSubmit;
  var bem = (0, _util.bemClass)('revisions-form');
  return /*#__PURE__*/_react.default.createElement("form", {
    onSubmit: handleSubmit
  }, children, /*#__PURE__*/_react.default.createElement("div", {
    className: bem('submit-button')
  }, /*#__PURE__*/_react.default.createElement(_reactComponents.Button, {
    type: "submit",
    disabled: !formState.isValid
  }, "Select Option")));
};
Form.propTypes = {
  children: _propTypes.default.node.isRequired,
  formState: _propTypes.default.shape({
    isValid: _propTypes.default.bool
  }).isRequired,
  handleSubmit: _propTypes.default.func.isRequired
};
var _default = exports.default = Form;
